export default (request) => ({
  getMyInfo: (options = {}) => request({
    method: 'get',
    url: '/clients/auth/me',
    ...options,
  }),

  updateUserPassword: (data, options = {}) => request({
    method: 'patch',
    url: '/clients/auth/password/update',
    data,
    ...options,
  }),
});
